import { takeLatest, put, call } from 'redux-saga/effects'

import { types, updateContact } from '@store/ducks/simulate'
import { setRedirectAction } from '@store/ducks/application'

import { getContactFromToken } from '@client/services/contact'

function* getContactFromMagicLink({ magicLink }) {
  try {
    const data = yield call(getContactFromToken, magicLink)
    yield put(updateContact(data))
  } catch (error) {
    yield put(setRedirectAction('/'))
  }
}

export default function*() {
  yield takeLatest(types.LOAD_FROM_MAGIC_LINK, getContactFromMagicLink)
}
